import * as React from "react";

import "./Icon.css";

const SvgEditIcon = ({ width, height, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 60 60"
    width={width || undefined}
    height={height ? height : "auto"}
    fill="currentColor"
    {...props}
    className={`svg-icon shake-two-icon-target ${props.className || ""}`}
    style={{
      transformOrigin: "center",
      ...props.style,
      ...(width ? { width: width } : {}),
      ...(height ? { height: height } : {}),
    }}
  >
    <g transform="translate(6,6)">
      <path d="M6.54 30.53 24.52 12.55l10.84 10.84L17.38 41.37zM30.784 6.274 37.05.01l10.84 10.84-6.265 6.265zM0 45.49l2.4 2.41 12.95-4.51L4.51 32.55zM25.41 11.64l4.454-4.454 10.84 10.84-4.455 4.454z" />{" "}
    </g>
  </svg>
);
export default SvgEditIcon;
